import { IJsonQuery } from '../../../../packages/api-models/common/json_query';
import { fetchGetMeta, TGetMetaResponse } from '../../repositories/search-offers-index/v1/get-meta';
import { IApplicationContext } from '../../types/applicationContext';
import { ISearchMeta } from '../../types/searchMeta';
import { ResponseError } from '../../utils/errors/ResponseError';

export async function getSearchMeta(context: IApplicationContext, jsonQuery: IJsonQuery): Promise<ISearchMeta> {
  const { httpApi, logger } = context;

  try {
    const response: TGetMetaResponse = await fetchGetMeta({
      httpApi,
      parameters: {
        jsonQuery,
      },
    });

    if (response.statusCode !== 200) {
      throw new ResponseError({
        domain: 'getSearchCatalogLocation',
        message: response.response.message || '',
      });
    }

    return response.response;
  } catch (error) {
    logger.error(error);

    throw error;
  }
}
